import React from 'react'
import { Typography, Grid } from '@material-ui/core';
import { useStyles, pinLocation } from './investedProjects.module';
import ButtonDefault from '../button/button';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';

const InvestedProjects = (props) => {
    const classes = useStyles();

    return (
        <div>
            <Grid container spacing={0} className={classes.contentInvestedProjects}>
                <Grid
                    item
                    lg={5}
                    md={5}
                    sm={5}
                    xs={12}
                >
                    <img className={classes.imageInvestedProjects} src={props.srcInvestedProjects} alt="Invested Projects" />
                </Grid>
                <Grid
                    item
                    lg={7}
                    md={7}
                    sm={7}
                    xs={12}
                    className={classes.contentInvestedProjectsTitle}
                >
                    <Typography
                        className={classes.titleInvestedProjects}
                    >
                        {props.title_investedProjects}
                    </Typography>
                    <div className={classes.containerCountryInvestedProjects}>
                        <img src={pinLocation} alt="country"
                            className={classes.pinLocationInvestedProjects} />
                        <Typography
                            className={classes.countryInvestedProjects}
                        >
                            {props.country_investedProjects}
                        </Typography>
                    </div>
                    <Typography
                        className={classes.nftsInvestedProjects}
                    >
                        {props.nfts_investedProjects}
                    </Typography>
                    <Typography
                        className={classes.descriptionInvestedProjects}
                    >
                        {props.description_investedProjects}
                    </Typography>
                    <Grid container spacing={0} >
                        <Grid
                            item
                            lg={4}
                            md={4}
                            sm={12}
                            xs={12}
                            className={classes.contentButtonViewPerformance}

                        >
                            <ButtonDefault
                                type="backgroundgreen"
                                text={props.textPerformance}
                                changeView={props.changeViewPerformance}
                            >
                                <ArrowRightAltIcon className={classes.iconInvestedProjectsTitle} />
                            </ButtonDefault>
                        </Grid>
                        <Grid
                            item
                            lg={8}
                            md={8}
                            sm={12}
                            xs={12}
                            className={classes.contentButtonViewPerformance}
                        >
                            <ButtonDefault
                                type="whiteborderblue"
                                text={props.textCertificate}
                                changeView={props.changeViewCertificate}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default InvestedProjects